module.exports = __webpack_public_path__ + "media/doneScan.b4a9472c.mp3";